export default {
      id: "ArrowDown-usage",
      viewBox: "0 0 11 6",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#ArrowDown",
      toString: function () {
        return this.url;
      }
    }